import React from 'react'
import 'fa-icons';


export const WarehouseDash = (props) => {
  return (
    <div>
     

                 <a href="/home">
                    <i className='bi bi-house-door'></i>
                </a>

            <h3>Stoporder Verification</h3>
            <br />

       

            <div className='card_10'>
                <h4>Fetched Growers</h4>
                <br />

                    <div class="row">
                        <div class="col-3">
                            <input type="search" id="form1" className="form-control input-sm" placeholder='Search' />
                            
                        </div>
                        <div className='col-3'>
                            <button type="button" class="btn btn-primary" data-mdb-ripple-init>
                            Submit
                            </button>

                        </div>   
                    </div>
                        <br />
                
             <div className='table-responsive' data-bs-spy="scroll" style={{ maxHeight: "500px", 
                    overflowY: "auto" }} >
                <table className='table table-striped'>
                    <thead style={{ position: "sticky", 
                    top: "0" }} className='card_10'>
                        <th>Sale Date</th>
                        <th>Grower</th>
                        <th>Name</th>
                        <th>Selling Point</th>
                        <th>Season</th>
                    </thead><br />
                    <tbody>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                            <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                        <tr data-bs-toggle="modal" data-bs-target="#example2">
                        <td>15-05-2024</td>
                            <td>V123</td>
                            <td>Bright Kaponda</td>
                            <td>VLT</td>
                            <td>2024</td>
                        </tr>
                    </tbody>
                </table>
             

               </div>     

            </div>
                

            {/* Modals */}

                <div className="modal fade" id="example2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Grower Stoporders</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">

                        <div>
                                <h4>V123456</h4>
                                <h6>Tafadzwa Maduuro</h6>
                                <p>66-084355-v-04</p>
                            </div>
                        <div className='card_10'>
                        <div className='table-responsive' style={{ maxHeight: "250px", 
                            overflowY: "auto", maxWidth: "auto" }}>
                            <table className='table table-striped table-hover tableFixHead '>
                                <thead className='card_10' style={{ position: "sticky", 
                                    top: "0" }}>
                                    <tr>

                                    <th>Creditor #</th>
                                    <th>Creditor Name</th>
                                    <th>Season</th>
                                    <th>Type</th>
                                    <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        
                                        <td>61512</td>
                                        <td>VLT</td>
                                        <td>2024</td>
                                        <td>USD</td>
                                        <td>250</td>
                                    </tr>
                                    <tr>
                                    
                                        <td>61512</td>
                                        <td>VLT</td>
                                        <td>2024</td>
                                        <td>USD</td>
                                        <td>250</td>
                                    </tr>

                                    <tr>
                                    
                                        <td>61512</td>
                                        <td>VLT</td>
                                        <td>2024</td>
                                        <td>USD</td>
                                        <td>250</td>
                                    </tr>
                                    <tr>
                                    
                                        <td>61512</td>
                                        <td>VLT</td>
                                        <td>2024</td>
                                        <td>USD</td>
                                        <td>250</td>
                                    </tr>
                                    <tr>
                                    
                                        <td>61512</td>
                                        <td>VLT</td>
                                        <td>2024</td>
                                        <td>USD</td>
                                        <td>250</td>
                                    </tr>
                                    <tr>
                                    
                                        <td>61512</td>
                                        <td>VLT</td>
                                        <td>2024</td>
                                        <td>USD</td>
                                        <td>250</td>
                                    </tr>
                                    <tr>
                                    
                                        <td>61512</td>
                                        <td>VLT</td>
                                        <td>2024</td>
                                        <td>USD</td>
                                        <td>250</td>
                                    </tr>
                                    <tr>
                                    
                                        <td>61512</td>
                                        <td>VLT</td>
                                        <td>2024</td>
                                        <td>USD</td>
                                        <td>250</td>
                                    </tr>
                                   
                                </tbody>

                            </table>
                            </div>
                            </div>
                        
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                        </div>
                    </div>
            </div>

        </div>
   
  )
}
